import { createRoute } from '@tanstack/react-router'
import { Route as authLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/auth/login',
}).lazy(() => import('./login.lazy').then((d) => d.Route))
